import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Umum Sekolah")
], -1)
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Initial", -1)
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email", -1)
const _hoisted_19 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-lg-6 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-6 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tipe Sekolah", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Tipe Sekolah", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", {
  value: "School",
  key: "School"
}, "Sekolah", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", {
  value: "Boarding_School",
  key: "Boarding_School"
}, " Boarding School ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", {
  value: "Boarding_School",
  key: "Boarding_School"
}, " Yayasan ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", {
  value: "Boarding_School",
  key: "Boarding_School"
}, " ISP ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", {
  value: "Boarding_School",
  key: "Boarding_School"
}, " Rumah Sakit ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", {
  value: "Boarding_School",
  key: "Boarding_School"
}, " Instansi ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", {
  value: "Boarding_School",
  key: "Boarding_School"
}, " Lainnya ", -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 fv-row" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Alamat Sekolah")
], -1)
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-6 fv-row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Pilih Provinsi ")
const _hoisted_44 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "col-lg-6 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Pilih Kota / Kabupaten ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Pilih Kota / Kabupaten ")
const _hoisted_51 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-6 fv-row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Pilih Kecamatan ")
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Pilih Kecamatan ")
const _hoisted_59 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "col-lg-6 fv-row" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Alamat", -1)
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Khusus")
], -1)
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-lg-6 fv-row" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Bank", -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Pilih Bank ")
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "col-lg-6 fv-row" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Area", -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Pilih Area ")
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Pilih Area ")
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-lg-6 fv-row" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Cabang", -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Pilih Cabang ")
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Pilih Cabang ")
const _hoisted_82 = { class: "col-lg-6 fv-row" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Funding", -1)
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = { class: "row mb-6" }
const _hoisted_87 = { class: "col-lg-6 fv-row" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor NPWP", -1)
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "col-lg-6 fv-row" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Input NPWP", -1)
const _hoisted_93 = ["src"]
const _hoisted_94 = { class: "fv-plugins-message-container" }
const _hoisted_95 = { class: "fv-help-block" }
const _hoisted_96 = { class: "row mb-6" }
const _hoisted_97 = { class: "col-lg-6 fv-row" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Status", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi PIC dan Sales")
], -1)
const _hoisted_100 = { class: "row mb-6" }
const _hoisted_101 = { class: "col-lg-6 fv-row" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama PIC ", -1)
const _hoisted_103 = { class: "fv-plugins-message-container" }
const _hoisted_104 = { class: "fv-help-block" }
const _hoisted_105 = { class: "col-lg-6 fv-row" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email PIC", -1)
const _hoisted_107 = { class: "fv-plugins-message-container" }
const _hoisted_108 = { class: "fv-help-block" }
const _hoisted_109 = { class: "row mb-6" }
const _hoisted_110 = { class: "col-lg-6 fv-row" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon PIC", -1)
const _hoisted_112 = { class: "fv-plugins-message-container" }
const _hoisted_113 = { class: "fv-help-block" }
const _hoisted_114 = { class: "col-lg-6 fv-row" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Sales Area", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sales Area", -1)
const _hoisted_117 = ["label", "value"]
const _hoisted_118 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" }, " warna hijau sebagai prioritas sales area ", -1)
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Tambahan")
], -1)
const _hoisted_122 = { class: "row mb-6" }
const _hoisted_123 = { class: "col-lg-6 fv-row" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Catatan", -1)
const _hoisted_125 = { class: "fv-plugins-message-container" }
const _hoisted_126 = { class: "fv-help-block" }
const _hoisted_127 = { class: "col-lg-6 fv-row" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Target Live", -1)
const _hoisted_129 = { class: "fv-plugins-message-container" }
const _hoisted_130 = { class: "fv-help-block" }
const _hoisted_131 = { class: "row mb-6" }
const _hoisted_132 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Referensi Dari", -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Referensi", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("option", {
  value: "Media Sosial",
  key: "Media Sosial"
}, " Media Sosial ", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("option", {
  value: "Bank",
  key: "Bank"
}, "Bank", -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("option", {
  value: "Webinar",
  key: "Webinar"
}, "Webinar", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("option", {
  value: "Iklan",
  key: "Iklan"
}, "Iklan", -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("option", {
  value: "Relasi",
  key: "Relasi"
}, "Relasi", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("option", {
  value: "Lainnya",
  key: "Lainnya"
}, "Lainnya", -1)
const _hoisted_141 = { class: "fv-plugins-message-container" }
const _hoisted_142 = { class: "fv-help-block" }
const _hoisted_143 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_144 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Referensi Dari", -1)
const _hoisted_145 = {
  key: 2,
  class: "col-lg-6 fv-row"
}
const _hoisted_146 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Implementator", -1)
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" Pilih Implementator ")
const _hoisted_148 = {
  key: 3,
  class: "col-lg-6 fv-row"
}
const _hoisted_149 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Implementator", -1)
const _hoisted_150 = /*#__PURE__*/_createTextVNode(" Pilih Implementator ")
const _hoisted_151 = {
  key: 1,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_152 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_153 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_155 = [
  _hoisted_153,
  _hoisted_154
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveNpwp()))
        }, {
          default: _withCtx(() => [
            (_ctx.items.role != 'ADMIN_CARD')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nama Sekolah",
                        modelValue: _ctx.editSekolah.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editSekolah.name) = $event))
                      }, null, 8, ["modelValue"]),
                      (_ctx.editSekolah.name == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.items.errorschoolName), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11))
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "initial",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Initial",
                        modelValue: _ctx.editSekolah.initial,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editSekolah.initial) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ErrorMessage, { name: "initial" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "email",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Email",
                        modelValue: _ctx.editSekolah.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editSekolah.email) = $event))
                      }, null, 8, ["modelValue"]),
                      (_ctx.editSekolah.email != '' && _ctx.items.erroremail != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.items.erroremail), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "phone",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nomor Telepon",
                        modelValue: _ctx.editSekolah.phone,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editSekolah.phone) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_ErrorMessage, { name: "phone" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-lg fw-bold",
                        name: "schoolType",
                        autocomplete: "off",
                        modelValue: _ctx.editSekolah.schoolType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editSekolah.schoolType) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _hoisted_29,
                          _hoisted_30,
                          _hoisted_31,
                          _hoisted_32,
                          _hoisted_33,
                          _hoisted_34,
                          _hoisted_35
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_ErrorMessage, { name: "schoolType" })
                        ])
                      ])
                    ]),
                    _hoisted_38
                  ]),
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.editSekolah.address.province,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editSekolah.address.province) = $event)),
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Pilih Provinsi"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "",
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_43
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.provinsiOptions, (option) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: option.id,
                                  label: option.name,
                                  value: option.name,
                                  onClick: ($event: any) => (_ctx.pilihProv(option.id, option.name))
                                }, null, 8, ["label", "value", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.editSekolah.address.province === '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.items.errorprovince), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_46))
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          (_ctx.editSekolah.address.province !== '')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: _ctx.editSekolah.address.city,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editSekolah.address.city) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Kota/ Kabupaten"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_49
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kabupatenOptions, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.id,
                                      label: option.name,
                                      onClick: ($event: any) => (_ctx.pilihKab(option.id, option.name)),
                                      value: option.name
                                    }, null, 8, ["label", "onClick", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                disabled: "",
                                modelValue: _ctx.editSekolah.address.regency,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editSekolah.address.regency) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Kota / Kabupaten"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_50
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kabupatenOptions, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.id,
                                      label: option.name,
                                      onClick: ($event: any) => (_ctx.pilihKab(option.id, option.name)),
                                      value: option.name
                                    }, null, 8, ["label", "onClick", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                        ]),
                        _: 1
                      }),
                      (_ctx.editSekolah.address.city == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.items.errorcity), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_53))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          (_ctx.editSekolah.address.city === '')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                disabled: "",
                                modelValue: _ctx.editSekolah.address.regency,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editSekolah.address.regency) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Kecamatan"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_57
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kecamatanOptions, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.id,
                                      label: option.name,
                                      value: option.name
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: _ctx.editSekolah.address.regency,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editSekolah.address.regency) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Kecamatan"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_58
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kecamatanOptions, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.id,
                                      label: option.name,
                                      value: option.name
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                        ]),
                        _: 1
                      }),
                      (_ctx.editSekolah.address.regency == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.items.errorregency), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_61))
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "detail",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Alamat",
                        modelValue: _ctx.editSekolah.address.detail,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editSekolah.address.detail) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_ErrorMessage, { name: "detail" })
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_66,
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _hoisted_69,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeBank(_ctx.items.listBank.length))),
                            modelValue: _ctx.editSekolah.bankData,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editSekolah.bankData) = $event)),
                            multiple: "",
                            filterable: "",
                            "default-first-option": "",
                            placeholder: "Pilih Bank"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "",
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_70
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listBank, (option) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: option._id,
                                  label: option.name,
                                  value: option._id,
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeListArea(_ctx.editSekolah.bankData[0])))
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_ErrorMessage, { name: "bankData" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          (_ctx.editSekolah.bankData.length !== 0)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: _ctx.editSekolah.bankAreaId,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editSekolah.bankAreaId) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Bank"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_75
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listArea, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.areaId,
                                      label: option.areaName,
                                      onClick: ($event: any) => (_ctx.changeListBranch(option._id, option.areaId)),
                                      value: option.areaId
                                    }, null, 8, ["label", "onClick", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                disabled: "",
                                modelValue: _ctx.editSekolah.bankAreaId,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editSekolah.bankAreaId) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Bank"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_76
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listArea, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.areaId,
                                      label: option.areaName,
                                      onClick: ($event: any) => (_ctx.changeListBranch(option._id, option.areaId)),
                                      value: option.areaId
                                    }, null, 8, ["label", "onClick", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          (
                    _ctx.editSekolah.bankAreaId == null ||
                    _ctx.editSekolah.bankAreaId == ''
                  )
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                disabled: "",
                                modelValue: _ctx.editSekolah.bankBranchId,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editSekolah.bankBranchId) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Cabang"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_80
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listBranch, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option._id,
                                      label: option.branchName,
                                      value: option.branchId
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: _ctx.editSekolah.bankBranchId,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editSekolah.bankBranchId) = $event)),
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Cabang"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_81
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listBranch, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option._id,
                                      label: option.branchName,
                                      value: option.branchId
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "fundingName",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nama Funding",
                        modelValue: _ctx.editSekolah.fundingName,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editSekolah.fundingName) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createVNode(_component_ErrorMessage, { name: "fundingId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "number",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nomor NPWP",
                        modelValue: _ctx.editSekolah.npwp.number,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editSekolah.npwp.number) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createVNode(_component_ErrorMessage, { name: "number" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createElementVNode("img", {
                        alt: "npwp",
                        class: "img-fluid",
                        src: _ctx.items.url
                      }, null, 8, _hoisted_93),
                      _createElementVNode("input", {
                        class: "form-control form-control-lg mt-2",
                        name: "file",
                        type: "file",
                        onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleFileUpload($event))),
                        placeholder: "Upload File NPWP",
                        accept: "image/*"
                      }, null, 32),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _createVNode(_component_ErrorMessage, { name: "imageUrl" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _hoisted_98,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "status",
                        class: "form-control form-control-lg",
                        placeholder: "Status",
                        modelValue: _ctx.editSekolah.status,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editSekolah.status) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_99,
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "picName",
                        class: "form-control form-control-lg",
                        placeholder: "Isi PIC Sekolah",
                        modelValue: _ctx.editSekolah.picName,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editSekolah.picName) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("div", _hoisted_104, [
                          _createVNode(_component_ErrorMessage, { name: "picName" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _hoisted_106,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "picEmail",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Email PIC",
                        modelValue: _ctx.editSekolah.picEmail,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editSekolah.picEmail) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _createVNode(_component_ErrorMessage, { name: "picEmail" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _hoisted_111,
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "picPhone",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nomor Telepon PIC",
                        modelValue: _ctx.editSekolah.picPhone,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editSekolah.picPhone) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_112, [
                        _createElementVNode("div", _hoisted_113, [
                          _createVNode(_component_ErrorMessage, { name: "picPhone" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _hoisted_115,
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-lg fw-bold",
                        name: "salesArea",
                        autocomplete: "off",
                        modelValue: _ctx.editSekolah.salesArea,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.editSekolah.salesArea) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_116,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.user_sales_area, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option._id,
                              label: 
                    option.regions === true ? option.name + ' *' : option.name
                  ,
                              value: option._id,
                              style: _normalizeStyle(
                    option.regions === true
                      ? { color: '#00A86B' }
                      : { color: '#000000' }
                  )
                            }, null, 12, _hoisted_117))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.editSekolah.address.province)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, _hoisted_120))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_121,
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _hoisted_124,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "note",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Catatan",
                        modelValue: _ctx.editSekolah.note,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editSekolah.note) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("div", _hoisted_126, [
                          _createVNode(_component_ErrorMessage, { name: "note" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _hoisted_128,
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "targetLive",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Target Live",
                        modelValue: _ctx.editSekolah.targetLive,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editSekolah.targetLive) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("div", _hoisted_130, [
                          _createVNode(_component_ErrorMessage, { name: "targetLive" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    (_ctx.items.role === 'SUPER_ADMIN')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                          _hoisted_133,
                          _createVNode(_component_Field, {
                            as: "select",
                            class: "form-select form-select-lg fw-bold",
                            name: "referenceFrom",
                            autocomplete: "off",
                            modelValue: _ctx.editSekolah.referenceFrom,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.editSekolah.referenceFrom) = $event))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_134,
                              _hoisted_135,
                              _hoisted_136,
                              _hoisted_137,
                              _hoisted_138,
                              _hoisted_139,
                              _hoisted_140
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("div", _hoisted_142, [
                              _createVNode(_component_ErrorMessage, { name: "status" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.items.role != 'SUPER_ADMIN')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                          _hoisted_144,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "referenceFrom",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.editSekolah.referenceFrom,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.editSekolah.referenceFrom) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (
                _ctx.items.role === 'SUPER_ADMIN' ||
                _ctx.items.role === 'IMPLEMENTATOR_LEADER'
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                          _hoisted_146,
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.editSekolah.implementatorData,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.editSekolah.implementatorData) = $event)),
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Implementator"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_147
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.user_implementator, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option._id,
                                      label: option.name,
                                      value: option._id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (
                _ctx.items.role != 'SUPER_ADMIN' &&
                _ctx.items.role != 'IMPLEMENTATOR_LEADER'
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                          _hoisted_149,
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.editSekolah.implementatorData,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editSekolah.implementatorData) = $event)),
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Pilih Implementator",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "",
                                    value: "",
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_150
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.user_implementator, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option._id,
                                      label: option.name,
                                      value: option._id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.items.role != 'ADMIN_CARD')
              ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                  _createElementVNode("button", {
                    class: "btn btn-danger me-3",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$router.push('/superadmin/sekolah')))
                  }, " Batal "),
                  _createElementVNode("button", _hoisted_152, _hoisted_155, 512)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}